require("./stylesheets/app.scss");

require("file-loader?name=favicon.ico!./favicon.ico");

require("babel-polyfill");

require("whatwg-fetch");

require("indexeddbshim");

require("./asset-symbols/symbols.js");

require("./images-loader.js");

require("./language-dropdown/flags.js");